module.exports = __webpack_public_path__ + "img/portifolio_smarthome.f48eb51a.jpg";